import React, { useEffect, useState } from "react";
import { getInternRequestWithFullData } from "../../api/crud";
import InternRequestTable from "../../Components/InternRequestTable";
import { matchOptions } from "../../utils/function";
import { optionsBranch } from "../../data/branch-data";
import { generateStatus } from "../../utils/generateDisplay";
import { Box } from "@mui/material";

const DashboardInternship = () => {
  const [rowsData, setRowsData] = useState([]);

  const getData = async () => {
    const res = await getInternRequestWithFullData();
    console.log("getInternRequestWithFullData", res);

    const rows = res
      .filter((item) => +item.st_id && item.status != "0")
      .map((row) => {
        console.log(row?.st_id, { row });
        return {
          req_id: row?.req_id,
          st_id: row?.st_id,
          name: `${row?.internStudent?.name}, ${matchOptions(
            optionsBranch,
            row?.internStudent?.b_id
          )}`,
          company: row?.company?.name,
          status: row?.status,
          updated_at: "",
          internLocation: row?.internLocation,
        };
      });

    setRowsData(rows);
  };

  useEffect(() => {
    getData();
  }, []);

  const headCells = [
    {
      id: "req_id",
      numeric: true,
      disablePadding: false,
      label: "Request ID	",
    },
    {
      id: "st_id",
      numeric: true,
      disablePadding: false,
      label: "รหัสนิสิต	",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "ชื่อ - สกุล	",
    },
    // {
    //   id: "branch",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "สาขา",
    // },
    {
      id: "company",
      numeric: false,
      disablePadding: false,
      label: "สถานประกอบการ",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "สถานะ",
    },
    {
      id: "updated_at",
      numeric: false,
      disablePadding: false,
      label: "อัพเดทเมื่อ	",
    },
    {
      id: "internLocation",
      numeric: false,
      disablePadding: false,
      label: "",
    },
  ];

  return (
    <div>
      <InternRequestTable tableColumn={headCells} tableData={rowsData} />
    </div>
  );
};

export default DashboardInternship;
